import { render, staticRenderFns } from "./BuildingDetailCard.vue?vue&type=template&id=09e9d658&scoped=true&"
import script from "./BuildingDetailCard.vue?vue&type=script&lang=js&"
export * from "./BuildingDetailCard.vue?vue&type=script&lang=js&"
import style1 from "./BuildingDetailCard.vue?vue&type=style&index=1&id=09e9d658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e9d658",
  null
  
)

export default component.exports